<!--
* UIID: UI-DLB-MAP-160
* UI Name: Scanner Check In
* Modify Date: 2020/05/21
-->
<template>
  <dialog-drag
    :id="id"
    :ref='"dialog-" + id'
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display add-map-layout-dialog custom-add-map-layout-dialog"
  >
    <!-- [S]  Popup title-->
    <template v-slot:title>
      <v-card-title
        class="headline white--text"
        primary-title>
        {{$t("lbl.mappingDefinition.mappingDefinitionCheckIn.pageHeader")}}
      </v-card-title>
    </template>
    <template v-slot:button-close>
      <!-- <v-icon class="ma-2" small @click="removeDialog" color="white">fas fa-times</v-icon> -->
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <!-- [E]  Popup title-->
    <!-- [S]  Popup body-->
    <v-card class="dialog-container">
      <v-form ref="form" class="pb-0 dialog-content">
        <v-row class="pt-0">
          <v-col lg="3" class="required-col field-col pt-0 pb-0">
            <v-label>
              <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
              {{$t("lbl.mappingDefinition.mappingDefinitionCheckIn.mappingDefinition")}}
            </v-label>
          </v-col>
          <v-col lg="9"
              class="map-text-field inline-block-component pt-0 pb-0 pl-0 pr-3">
            <v-text-field
              v-model="contenInput"
              class="data-table-filter-text-field inline-block-component"
              type="text"
              solo
              readonly
              :rules="[validationUtils.required]"
            >
            </v-text-field>
            <input
              @change="onFileChanged"
              id="mpdfile"
              ref="mpdfile"
              type="file"
              style="display: none"
            >
            <v-btn class="ml-2 btn btn-popup-search" color="primary" @click="clickBrowse">
              {{$t("btn.common.browse")}}
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="pt-0">
          <v-col lg="3" class="required-col field-col pt-0 pb-0">
              <v-label>
                <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
                {{$t("lbl.mappingDefinition.mappingDefinitionCheckIn.comment")}}
              </v-label>
          </v-col>
          <v-col lg="9"
                class="map-text-field inline-block-component pl-0 pt-0 pb-0">
            <v-text-field
              v-model="contentComment"
              class="data-table-filter-text-field inline-block-component text-field-flatfile-layout flatfile-textfield"
              type="text"
              solo
              ref="comRef"
              :rules="[validationUtils.required]"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <!-- [S]  Popup button-->
        <v-divider class="mt-4 ml-0 mr-0 divder-popup" inset></v-divider>
        <v-row class="pt-0">
          <v-col lg="12" class="pb-0">
            <div class="btn-form-control text-right">
              <v-btn class="btn btn-delete" @click="removeDialog">
                {{$t('btn.common.cancel')}}
              </v-btn>
              <v-btn v-if="options.item.action == 'add'" class="btn btn-popup-search" color="primary" @click="saveCheckIn()">
                {{$t('btn.common.save')}}
              </v-btn>
              <v-btn v-if="options.item.action == 'checkIn'" class="btn btn-popup-search" color="primary" @click="checkInMap()">
                {{$t('btn.common.save')}}
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <!-- [E]  Popup button-->
        <!-- [E]  Popup body-->
      </v-form>
    </v-card>
    <dialogWindow
      ref="successDialog"
      size="max"
      title="Success"
      :detail="$t('msg.mappingDefinition.mapperCheckIn.saveSuccess')"
      color="success"
      @select-ok="saveSuccess"
    >
    </dialogWindow>
    <dialogWindow
      ref="detailDialog"
      size="max"
      :detail="detailDialog"
      color="warning"
      @select-ok="clickAlert"
    >
    </dialogWindow>
  </dialog-drag>
</template>

<script>
/* globals Store */

import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import { mapState } from "vuex";
/* 2020/11/06 203737 Remove unused source
import {UploadFile} from '@/vue-dlb/models'*/
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import IconSvg from "@/vue-caas/components/IconBase.vue";

import {
  showProgress,
  hideProgress,
} from "@/vue-dlb/utils/sys-util.js";

export default {
  components: {
      DialogDrag,
      dialogWindow,
      IconSvg
    },
    name: 'mapping-definnition-checkin',
    /* 2020/11/05 203737 Change prop definitions
    props: ['id', 'title', 'options', 'eventCb', 'closeDialog', 'dragStart', 'dragEnd', 'queryList','callby','versionList','reFreshList'],*/
    props:{
      id: String,
      options: Object,
      closeDialog: Function,
      dragStart: Function,
      dragEnd: Function,
      versionList: String,
      reFreshList: Function
    },
    computed: {
    /* 2020/11/11 203737 Remove unused source
    ...mapState("common", {
      uploadedFile: "uploadedFile"
    }),
    ...mapState("common", {
      fileContent: "fileContent",
    }),*/
  },
  data: () => ({
    /*
    Remove unuse code
    successDialog: false,
    fileLoaded: '',
    scannerName:'',
    */
    detailDialog: '',
    contenInput: '',
    isValidU: false,
    isValidC: false,
    contentComment: '',
    uploadCheckIn: {
      header: ['MPD_PRCS_NO','ADMIN_YN', 'CUST_ID', 'OWNR_CUST_ID', 'USER_ID', 'REPO_YN', 'MPD_CONV_TP', 'MPD_FILE_NAME','FILE_ID','FILE_SIZE','CHKIN_COMT'],
      data: [{
        MPD_PRCS_NO:'',
        ADMIN_YN:'',
        CUST_ID:'',
        OWNR_CUST_ID: '',
        USER_ID:'',
        REPO_YN:'',
        MPD_CONV_TP:'',
        MPD_FILE_NAME:'',
        FILE_ID:'',
        FILE_SIZE:'',
        CHKIN_COMT: '',
        mpdfile:null,
      }],
    },
    checkInItems: {
      header: ['CUST_ID','USER_ID', 'MPD_PRCS_NO', 'MPD_FILE_NAME', 'FILE_ID', 'FILE_SIZE', 'CHKIN_COMT'],
      data: [{
        CUST_ID:'',
        USER_ID:'',
        MPD_PRCS_NO:'',
        MPD_FILE_NAME:'',
        FILE_ID:'',
        FILE_SIZE:'',
        CHKIN_COMT: '',
        mpdfile:null,
      }],
    },
    lockItems:{
      header: ['MPD_PRCS_NO','LOCK_YN'],
      data: [{
        MPD_PRCS_NO:'',
        LOCK_YN:''
      }],
    },
  }),
  created(){
  },
  mounted() {
    setTimeout(() => {
        this.$refs.comRef.focus();
    }, 300);
  },
  methods: {
    saveCheckIn () {
      if (this.contenInput.trim() == '' || this.contentComment.trim() == '') {
        if (this.contenInput.trim() == '' && this.contentComment.trim() == '') {
          this.isValidU = true;
          this.isValidC = true;
          this.detailDialog = this.$t('msg.common.requires',["Mapping Definition, Comment"]);
        } else if (this.contenInput.trim() == '') {
          this.isValidU = true;
          this.isValidC = false;
          this.detailDialog = this.$t('msg.common.require',["Mapping Definition"]);
        } else if (this.contentComment.trim() == '') {
          this.isValidC = true;
          this.isValidU = false;
          this.detailDialog = this.$t('msg.common.require',["Comment"]);
        }
        this.$refs.detailDialog.dialog = true;
        return;
      }
      let validResult = this.$refs.form.validate();
      if (validResult) {
        console.log("--------- savaData ----------");
         if(this.$refs.mpdfile.files[0]) {
          this.uploadCheckIn.data[0].MPD_PRCS_NO = '';
          this.uploadCheckIn.data[0].ADMIN_YN = "N";
          this.uploadCheckIn.data[0].CUST_ID = $cookies.get('comp-id');
          this.uploadCheckIn.data[0].OWNR_CUST_ID = $cookies.get('ownr-id');
          this.uploadCheckIn.data[0].USER_ID = 'UserId';
          this.uploadCheckIn.data[0].REPO_YN = 'N';
          this.uploadCheckIn.data[0].MPD_CONV_TP = '';
          this.uploadCheckIn.data[0].MPD_FILE_NAME = '';   // TBD - by April. Please check here too.
          this.uploadCheckIn.data[0].FILE_ID = '';    // TBD - by April. Please set scanner file id saved on a scrren.
          this.uploadCheckIn.data[0].FILE_SIZE = '';
          this.uploadCheckIn.data[0].CHKIN_COMT = this.contentComment;
          this.uploadCheckIn.data[0].mpdfile = this.$refs.mpdfile.files[0];
          // Upload Flat File Data
          showProgress();
          Store.dispatch("mapdefinition/saveAddMapDefinition", this.uploadCheckIn).then(() => {
            console.log("--------- Finished to process ----------");
            hideProgress();
            this.$refs.successDialog.dialog = true;
          });
      }}
      return validResult;
    },
    checkInMap () {
      if (this.contenInput.trim() == '' || this.contentComment.trim() == '') {
        if (this.contenInput.trim() == '' && this.contentComment.trim() == '') {
          this.isValidU = true;
          this.isValidC = true;
          this.detailDialog = this.$t('msg.common.requires',["Mapping Definition, Comment"]);
        } else if (this.contenInput.trim() == '') {
          this.isValidU = true;
          this.isValidC = false;
          this.detailDialog = this.$t('msg.common.require',["Mapping Definition"]);
        } else if (this.contentComment.trim() == '') {
          this.isValidC = true;
          this.isValidU = false;
          this.detailDialog = this.$t('msg.common.require',["Comment"]);
        }
        this.$refs.detailDialog.dialog = true;
        return;
      }
      let validResult = this.$refs.form.validate();
      if (validResult) {
        console.log("--------- savaData ----------");
         if(this.$refs.mpdfile.files[0]) {
          this.checkInItems.data[0].MPD_PRCS_NO = this.options.item.data.MPD_PRCS_NO;
          this.checkInItems.data[0].CUST_ID = $cookies.get('comp-id');
          this.checkInItems.data[0].USER_ID = 'UserId';
          this.checkInItems.data[0].MPD_FILE_NAME = '';
          this.checkInItems.data[0].FILE_ID = '';
          this.checkInItems.data[0].FILE_SIZE = '';
          this.checkInItems.data[0].CHKIN_COMT = this.contentComment;
          this.checkInItems.data[0].mpdfile = this.$refs.mpdfile.files[0];
          console.log(this.checkInItems);
          // Upload Flat File Data
          showProgress();
          Store.dispatch("mapdefinition/checkInMapDefinition", this.checkInItems).then(() => {
            console.log("--------- Finished to process ----------");
            hideProgress();
            this.$refs.successDialog.dialog = true;
          });
      }}
      return validResult;
    },
    clickAlert(){
       let self = this;
      setTimeout(() => {
        self.$refs.comRef.focus();
      }, 600);
    },
    saveSuccess(){
      this.onClickOkaySave();
      this.removeDialog({});
    },
    onClickOkaySave (){
      this.lockItems.data[0].MAP_PRCS_NO = this.versionList.MAP_PRCS_NO;
      this.lockItems.data[0].LOCK_YN = 'N';

      Store.dispatch("mapdefinition/updateLock", this.lockItems).then(() => {
        console.log("--------- Finished to process CHECKOUT ----------");
        this.reFreshList();
      });
    },
    clickBrowse() {
      this.$refs.mpdfile.click();
    },
    onFileChanged(e) {
      this.contenInput = e.target.files[0].name;
    },
    removeDialog (dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog (obj) {
      this.dragStart(obj);
    },
    dialogDragEnd (obj) {
        this.dragEnd(obj);
    },
  },
}
</script>

<style>
.card-upload-content-version .mapping-definition-ip .v-label{
  width: 149px;
}
.dialog-drag .dialog-body .mapping-definition-ip .dv_comment{
    width: calc(100% - 149px);
}
</style>
